import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { FC } from 'react';

import { ChatSwitchTabs } from '@/components/ui/shared/chat/ChatPopup/components/types';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { queryEventChatChannelNotifications } from '@/queries/notifications';

interface IChatSwitcherProps {
  setSelected: (tab: ChatSwitchTabs) => void;
  selected: ChatSwitchTabs;
}

export const ChatSwitcher: FC<IChatSwitcherProps> = ({ selected, setSelected }) => {
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  const { meta } = useResources(queryEventChatChannelNotifications(eventId), { refreshInterval: 60 * 1000 });

  const totalUnread = (meta?.totalUnreadCount || 0) as number;

  return (
    <Flex bg="gray.100" p={1} borderRadius="full" justify="space-between" align="center" position="relative">
      <Box
        position="absolute"
        left={selected === ChatSwitchTabs.PEOPLE ? 0 : '50%'}
        w="50%"
        h="100%"
        bg="black"
        borderRadius="full"
        transition="left 0.3s"
      />
      <Button
        flex={1}
        onClick={() => setSelected(ChatSwitchTabs.PEOPLE)}
        color={selected === ChatSwitchTabs.PEOPLE ? 'white' : 'black'}
        height={8}
        variant="unstyled"
        _focus={{ boxShadow: 'none' }}
      >
        all people
      </Button>
      <Button
        flex={1}
        height={8}
        onClick={() => setSelected(ChatSwitchTabs.MESSAGES)}
        color={selected === 'messages' ? 'white' : 'black'}
        variant="unstyled"
        _focus={{ boxShadow: 'none' }}
      >
        <Flex justifyContent="center" alignItems="center">
          messages{' '}
          {totalUnread > 0 && (
            <Flex ml={2} w={5} h={5} bg="almostRed.500" borderRadius="50%" justifyContent="center" alignItems="center">
              <Text fontFamily="heading" fontWeight="normal" color="white" fontSize="10px">
                {totalUnread}
              </Text>
            </Flex>
          )}
        </Flex>
      </Button>
    </Flex>
  );
};
